<script>
  import http from '@/service/http'
  import { FullCalendar } from 'vue-full-calendar'
  import '../../../node_modules/fullcalendar/dist/locale/pt-br'

  export default {
    name: 'Cronograma',
    components: {
      FullCalendar
    },
    data () {
      return {
        config: {
          locale: 'pt-BR',
          lang: 'pt-br',
          defaultView: 'month',
          editable: false,
          header: {
            left: '',
            center: '',
            right: 'month,basicWeek,basicDay'
          }
        },
        eventos: [],
        filtro: {
          mes: '',
          ano: '',
          dia: '',
          usuario: ''
        },
        usuarios: [],
        usuario: null
      }
    },
    mounted () {
      if (window.location.hash.indexOf('forbidden=true') > -1) {
        this.$bus.$emit('sweet-erro', {
          message: 'Acesso não permitido'
        })
      }
      this.filtrar()
    },
    methods: {
      async filtrar () {
        const {data} = await http.get(`/cronograma?mes=${this.filtro.mes}&ano=${this.filtro.ano}&usuario=${this.filtro.usuario}`)
        this.eventos = data.eventos
        this.filtro = data.filtro
        this.usuarios = data.usuarios
        this.config.defaultDate = this.filtro.ano + '-' + this.filtro.mes + '-' + this.filtro.dia
        this.$refs.calendar.$emit('reload-events')
        this.$refs.calendar.fireMethod('gotoDate', `${this.filtro.ano}-${this.filtro.mes}-${this.filtro.dia}`)
        setTimeout(function () {
          window.Materialize.updateTextFields()
        }, 0)
      }
    },
    computed: {}
  }
</script>

<template>
  <div>

    <div class="content">

      <div class="row">
        <div class="col s12 m7">
          <h5>Cronograma</h5>
        </div>
      </div>

      <form @submit.prevent="filtrar">

        <div class="row">

          <div class="col s12 m2">
            <label for="filtro_mes">Mês</label>
            <select name="mes" id="filtro_mes" v-model="filtro.mes">
              <option value="01">Janeiro</option>
              <option value="02">Fevereiro</option>
              <option value="03">Março</option>
              <option value="04">Abril</option>
              <option value="05">Maio</option>
              <option value="06">Junho</option>
              <option value="07">Julho</option>
              <option value="08">Agosto</option>
              <option value="09">Setembro</option>
              <option value="10">Outubro</option>
              <option value="11">Novembro</option>
              <option value="12">Dezembro</option>
            </select>
          </div>
          <div class="input-field col s12 m1">
            <label for="ano">Ano</label>
            <input type="number" maxlength="4" v-model="filtro.ano" id="ano">
          </div>

          <div class="col s12 m3">
            <label for="usuario">Usuário</label>
            <select name="usuario" id="usuario" v-validate data-vv-rules="required" v-model="filtro.usuario">
              <option v-for="usuario in usuarios" :value="usuario.id">{{ usuario.nome_completo }}</option>
            </select>
          </div>

          <div class="input-field col s12 m3">
            <button class="waves-effect waves-light btn" type="submit"><i class="material-icons left">filter_list</i> Filtrar</button>
          </div>

        </div>

      </form>

      <div class="row">
        <div class="col s12">

          <full-calendar :events="eventos" :config="config" ref="calendar"></full-calendar>

        </div>
      </div>

    </div>


  </div>
</template>

<style>
  @import '../../../node_modules/fullcalendar/dist/fullcalendar.css';
</style>



// WEBPACK FOOTER //
// src/features/dashboard/cronograma.vue